var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createBindContext, executeText, keyPassphraseRequiredFromError, LanguageError, resolveFkRowId, resolveRowIdPrefix, } from "@hyper-hyper-space/hhs3_rdb_runtime";
import { renderStatementMain } from "./format/table.js";
export { createBindContext, LanguageError, keyPassphraseRequiredFromError, resolveRowIdPrefix, resolveFkRowId, };
export function runLanguageText(session, text, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const runtimeOptions = (options === null || options === void 0 ? void 0 : options.onProgress) === undefined
            ? options
            : Object.assign(Object.assign({}, options), { onProgress: undefined });
        const run = yield executeText(session, text, runtimeOptions);
        return mapRuntimeResults(session, run, options);
    });
}
function mapRuntimeResults(session, run, options) {
    return {
        results: run.results.map((item) => {
            var _a, _b;
            const mapped = {
                result: item.result,
                notices: (_a = item.events) === null || _a === void 0 ? void 0 : _a.map((event) => event.message),
            };
            if ((options === null || options === void 0 ? void 0 : options.onProgress) !== undefined && session.outputMode !== 'json') {
                const main = renderStatementMain(session, mapped);
                if (main.length > 0) {
                    options.onProgress(main);
                    mapped.mainStreamed = true;
                }
                for (const notice of (_b = mapped.notices) !== null && _b !== void 0 ? _b : []) {
                    options.onProgress(notice);
                    mapped.noticesStreamed = true;
                }
            }
            return mapped;
        }),
    };
}
